module.exports = {
  /**
   * @description 网站标题
   */
  title: '快缴费管理系统',
  /**
   * @description 是否显示 头部标签
   */
  tagsView: true,
  /**
   * @description 固定头部
   */
  fixedHeader: true,
  /**
   * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
   */
  tokenCookieExpires: 1,
  /**
   * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天
   */
  passCookieExpires: 1,
  /**
   * @description 是否只保持一个子菜单的展开
   */
  uniqueOpened: true,
  /**
   * @description token key
   */
  TokenKey: 'DC-ADMIN-TOEKN',
  /**
   * @description 请求超时时间，毫秒（默认2分钟）60000
   */
  timeout: 1200000,
  /**
   * @description 是否显示logo
   */
  sidebarLogo: true,
  /**
   * 是否显示设置的底部信息
   */
  showFooter: true,
  /**
   * 底部文字，支持html语法
   */
  footerTxt: 'Copyright © 版本所有 广州快猫科技有限公司',
  /**
   * 备案号
   */
  caseNumber: '粤ICP备2022144236号-2',
  // tokenDomain: process.env.NODE_ENV === 'production' ? '.sujiaofei.com' : '192.168.1.106'
  tokenDomain: process.env.NODE_ENV === 'production' ? window.location.host : '192.168.1.106'
}



// WEBPACK FOOTER //
// ./src/utils/globalSettings.js